import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/title/detail'
const api = createApi(baseUrl)

// 用户相关API
export const articleTitleDetailApi = {
  list: api('list', 'get'),
  delete: api('delete', 'get'),
  update: api('update', 'post'),
}